import { BROADCAST_SET_DESIRED_ATTENDEE_MUTE_STATUS } from 'actions/Types';
import { MUTE_CHANGE } from 'store/eventConstants';
import { UNASSIGNED } from 'utils/broadcastSourceHelper';
import { setAttendeeMuteStatus } from '@shoflo/studio-redux/actions';
import { debounce } from 'underscore';
import emitSocketEvent from '@shoflo/studio-redux/utils/emitSocketEvent';
import { DEBOUNCE_PROGRAM_UPDATES } from '@studio/constants';

/*
 * This action is used to set the desired attendee mute status.
 * If the attendeeId in this instance is an unassigned source, we want the reducer to update the mic state.
 * If the attendeeId is a valid Camera Source, we dont want the reducer to update the state.
 * We have a `subscribeToVolumeIndicator` function in the chimeSession/initialize.js
 * file which has a chime observer that notifies us when the mic state of attendees changes.
 * we use this to update the UI mic state.
 */
export default (attendeeId, isMuted) => {
  return (dispatch, getState, socket) => {
    const { broadcast } = getState();
    let actionPayload = {};
    const action = {
      type: BROADCAST_SET_DESIRED_ATTENDEE_MUTE_STATUS,
      request: async () => {
        const payload = {
          isMuted,
          attendeeId,
          broadcastId: broadcast && broadcast._id
        };
        debouncedMuteStatusChange(socket, MUTE_CHANGE, payload);
        if (attendeeId.includes(UNASSIGNED)) {
          dispatch(setAttendeeMuteStatus(attendeeId, isMuted));
        }
        return Object.create(null);
      },
      payload: actionPayload
    };
    dispatch(action);
  };
};

const debouncedMuteStatusChange = debounce(
  emitSocketEvent,
  DEBOUNCE_PROGRAM_UPDATES
);
